
import { defineComponent } from 'vue';

import { ClientCustomComponentSetup } from '@/components/ClientCustomComponentBase';

export default defineComponent({
  name: 'PcClientCustomComponent',
  props: {
    type: String,
    company: String,
    device: String
  },
  setup(props) {
    return ClientCustomComponentSetup(props);
  }
});
